import React, { Component } from 'react';
import { withRouter } from 'react-router-dom'
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';

import InputWithExtra from '../../Comman/components/InputWithExtra';
//import Popup from 'reactjs-popup'
import Modal from 'react-responsive-modal';

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { TwitterPicker ,ChromePicker,  } from 'react-color';
import 'primereact/resources/primereact.min.css';
import { confirmAlert } from 'react-confirm-alert'; // Import
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css
import {InputText} from 'primereact/inputtext';
import SimpleReactValidator from 'simple-react-validator';
import noimage from '../../Comman/images/no_image.png';
import loader from '../../Comman/images/loader.gif'
import {baseUrl} from '../../Comman/apiEndPoints'
import swal from 'sweetalert';
import { withNamespaces } from 'react-i18next';

var OptionsCounterDet=0;
var EmojiCounterDet=0;
var rowData;
var svValidator;
var engValidator;
const sleep = (milliseconds) => {
    return new Promise(resolve => setTimeout(resolve, milliseconds))
}
const url=baseUrl;
const popover = {
      position: 'absolute',
      zIndex: '2',
    }
    const cover = {
      position: 'fixed',
      top: '0px',
      right: '0px',
      bottom: '0px',
      left: '0px',
    }
class AppFeedbackSettingComponent extends Component {
    toastId = null;
    constructor(props) {
        super(props); 
        this.state = {
            open: false,
            feedbackSettings: {
                QuestionId: 0,
                QuestionTypeId: "1" ,
                FeedbackTypeId : '1',
                QuestionText:'' ,
                // Mandatory:false,
                // Hidden:false
            } 
        };
        this.handleInput = this.handleInput.bind(this); 
       // this.deleteNotificationSettings= this.deleteNotificationSettings.bind(this);
        this.openModal = this.openModal.bind(this);
        this.closeModal = this.closeModal.bind(this); 
         this.updateQuestionDetailsSettings = this.updateQuestionDetailsSettings.bind(this);
        this.actionColumn = this.actionColumn.bind(this); 
        this.baseState=this.state;
         
    }
 
    componentWillMount() { 
        SimpleReactValidator.addLocale('en', {
            required : 'The :attribute field is required.',
            min : 'The :attribute must be at least :min:type.'
        });
        SimpleReactValidator.addLocale('sv', {
            required : 'Fältet :attribute krävs.',
            min : ':attribute måste vara minst :min tecken.'
        });
        engValidator = new SimpleReactValidator(
            {
                locale : 'en'
            }
          ); 
          svValidator = new SimpleReactValidator(
            {
                locale : 'sv'
            }
          ); 
          this.validator = engValidator;
      }
    componentWillReceiveProps(nextProps) { 
        if (nextProps.feedbackSettings !== this.props.feedbackSettings) {
             if(nextProps.statusCode==200){
                    this.notify(nextProps.feedbackSettings.messageLabel)
                     this.closeModal();
                     this.setState(this.baseState);
                     this.props.getAppFeedbackQuesList();
            }
            if(nextProps.statusCode==201){
                this.errornotify(nextProps.feedbackSettings.messageLabel)
            }
        }
        this.translateLang();
    }
    translateLang(){
        var language;
        if(sessionStorage.getItem('Language')){
          language = sessionStorage.getItem('Language');
        }
        else{
          language = "en";
        }
        if(language == "en"){
          this.validator = engValidator;
        }
        else{
          this.validator = svValidator;
        }
      }
    handleInput(e) {   
        //debugger
       let value = e.target.value;
       let name = e.target.name;
        if(name == "QuestionTypeId"){
            if(value == "2"){
                OptionsCounterDet=0; 
                EmojiCounterDet=0;
                this.createOptionsTextbox();
            }
            if(value == "3"){
                OptionsCounterDet=0; 
                EmojiCounterDet=0;
                this.createEmojiOptions();
            }
        }
      this.setState( prevState => ({ feedbackSettings : 
        {...prevState.feedbackSettings, [name]: value}
        }),  ) 
}

    errornotify = (message) => {
        swal({text : message, icon : 'error'}) 
        // this.toastId =toast.error(message, {
        //   position: toast.POSITION.TOP_CENTER
        // }); 
      }

   
  closeModal() {
        this.setState({ open: false })
        this.setState(this.baseState); 
    }
   
    createOptionsTextbox(){ 
        const { t } = this.props;
         sleep(500).then(() => {  
             var rowData=this.props.feedbackSettings.questionList;
            rowData= rowData.filter(m=>m.QuestionId == this.state.feedbackSettings.QuestionId)[0];
         
            for(var v=0;v<rowData.Answers.length;v++){
                OptionsCounterDet=OptionsCounterDet+1;
                var optionDiv = document.createElement('div');
                optionDiv.id="optionDivMain_"+rowData.Answers[v].AnswerId;
                var input = document.createElement('input');
                input.type = 'text';
                input.class="formControl1";
               // input.id='mcqOptionText'+OptionsCounterDet;
                input.name = 'mcqOptionText'+OptionsCounterDet;
                input.title= "mcqOptionText"+OptionsCounterDet;  ;
                input.placeholder = `${t('Feedback Setting.Enter Option Text')}`; 
                input.value=rowData.Answers[v].AnswerText;
                input.id='mcqOptionText'+rowData.Answers[v].AnswerId;
               var divMcqOptions = document.getElementById('mcqOptions'); 
               optionDiv.appendChild(input); 

                var inputSpanDelete = document.createElement('span');
                 inputSpanDelete.tooltip="Delete";
                inputSpanDelete.onclick =this.DeleteMcqOption;
                inputSpanDelete.id='mcqOptionDel_'+rowData.Answers[v].AnswerId;
                var nbsp = document.createElement('span');
                nbsp.innerHTML="&nbsp";
                inputSpanDelete.appendChild(nbsp);
             var inputIDelete = document.createElement('i');
            // inputIDelete.id='mcqOptionDel_'+rowData.Answers[v].AnswerId;
             inputIDelete.className="fa fa-lg fa-trash";
             inputIDelete.ariaHidden="true";
             inputSpanDelete.appendChild(inputIDelete);
             optionDiv.appendChild(inputSpanDelete);

                var mybr = document.createElement('br');
                optionDiv.appendChild(mybr);
                divMcqOptions.appendChild(optionDiv);
            } 
    })
    } 
    createEmojiOptions(){
        const { t } = this.props;
        sleep(500).then(() => {   
        rowData=this.props.feedbackSettings.questionList;
        rowData= rowData.filter(m=>m.QuestionId == this.state.feedbackSettings.QuestionId)[0];
     
        for(var v=0;v<rowData.Answers.length;v++){
        EmojiCounterDet=EmojiCounterDet+1; 
        var optionDiv = document.createElement('div');
        optionDiv.id="emojiDivMain_"+rowData.Answers[v].AnswerId
    var input = document.createElement('input');
        input.type = 'text';
        input.class="formControl1";
      //  input.id='emojiOptionText'+EmojiCounterDet;
        input.name = 'emojiOptionText'+EmojiCounterDet;
        input.title= 'emojiOptionText'+EmojiCounterDet;  
        input.value=rowData.Answers[v].AnswerText;
        input.id='emojiOptionText'+rowData.Answers[v].AnswerId;
        input.placeholder = `${t('Feedback Setting.Enter Emoji Option Text')}`;
        var divEmojiOptions = document.getElementById('emojiOptions'); 
        optionDiv.appendChild(input); 
        var emojiList=this.props.feedbackSettings.emojiImage;
        emojiList.forEach(item => {
            var inputlbl ;
            inputlbl = document.createElement('label');
          inputlbl.key="EmojiImage"+item.Id;
          inputlbl.className="checkbox-inline";
    
     var  inputRad = document.createElement('input');
     inputRad.type = 'radio';
     inputRad.id='EmojiImageCB'+rowData.Answers[v].AnswerId;
     inputRad.name = 'EmojiImage'+rowData.Answers[v].AnswerId;  
     inputRad.key=item.Id;
     inputRad.value=item.Id;
     inputRad.checked = (item.Id == rowData.Answers[v].EmojiID) ? true : false;
     var  inputImg = document.createElement('img');
     inputImg.src=baseUrl+item.EmojiImage;
     inputImg.style.width="30px";
     inputImg.style.height="30px";
    
     inputlbl.appendChild(inputRad);
     inputlbl.appendChild(inputImg);
     var divEmojiOptions = document.getElementById('emojiOptions'); 
     optionDiv.appendChild(inputlbl);
          });
          var inputSpanDelete = document.createElement('span');
    inputSpanDelete.tooltip="Delete";
    inputSpanDelete.onclick =this.DeleteEmojiOption;
    inputSpanDelete.id='emojiOptionDel_'+rowData.Answers[v].AnswerId;
    var nbsp = document.createElement('span');
                nbsp.innerHTML="&nbsp";
                inputSpanDelete.appendChild(nbsp);
 var inputIDelete = document.createElement('i');
 inputIDelete.className="fa fa-lg fa-trash";
 inputIDelete.ariaHidden="true";
 inputSpanDelete.appendChild(inputIDelete);
 optionDiv.appendChild(inputSpanDelete);
 divEmojiOptions.appendChild(optionDiv);
          var ele=document.getElementsByName("EmojiImage"+EmojiCounterDet); 
          for(var i = 0; i < ele.length; i++) { 
             if(rowData.Answers[v].EmojiID == ele[i].value) 
                  ele[i].checked = true;  
        }
    }
})
}

DeleteMcqOption(e){ 
var elementId=(e.target.parentElement.id).split('_');
    var inputName="optionDivMain_"+parseInt(elementId[1]);
     var elementInput = document.getElementById(inputName);
      elementInput.parentNode.removeChild(elementInput); 
}

DeleteEmojiOption(e){ 
    var elementId=(e.target.parentElement.id).split('_');
    var inputName="emojiDivMain_"+parseInt(elementId[1]);
     var elementInput = document.getElementById(inputName);
      elementInput.parentNode.removeChild(elementInput); 
     
}

createTextbox(){
    const { t } = this.props;
    OptionsCounterDet=OptionsCounterDet+1;
    var optionDiv = document.createElement('div');
                optionDiv.id="optionDivMain_"+OptionsCounterDet;
    var input = document.createElement('input');
    input.type = 'text';
    input.class="formControl1";
    input.id='mcqOptionText'+OptionsCounterDet;
    input.name = 'mcqOptionText'+OptionsCounterDet;
    input.title= "mcqOptionText"+OptionsCounterDet;  ;
    input.placeholder = `${t('Feedback Setting.Enter Option Text')}`;
   var divMcqOptions = document.getElementById('mcqOptions'); 
   optionDiv.appendChild(input); 
 
    var inputSpanDelete = document.createElement('span');
    inputSpanDelete.tooltip="Delete";
    inputSpanDelete.onclick =this.DeleteMcqOption;
    inputSpanDelete.id='mcqOptionDel_'+OptionsCounterDet;
    var nbsp = document.createElement('span');
                nbsp.innerHTML="&nbsp";
                inputSpanDelete.appendChild(nbsp);
 var inputIDelete = document.createElement('i');
 inputIDelete.className="fa fa-lg fa-trash";
 inputIDelete.ariaHidden="true";
 inputSpanDelete.appendChild(inputIDelete);
 optionDiv.appendChild(inputSpanDelete);
    var mybr = document.createElement('br');
    optionDiv.appendChild(mybr);
    divMcqOptions.appendChild(optionDiv);
}

createEmojiTextbox(){ 
    const { t } = this.props;
    EmojiCounterDet=EmojiCounterDet+1; 
    var optionDiv = document.createElement('div');
    optionDiv.id="emojiDivMain_"+EmojiCounterDet;
var input = document.createElement('input');
    input.type = 'text';
    input.class="formControl1";
    input.id='emojiOptionText'+EmojiCounterDet;
    input.name = 'emojiOptionText'+EmojiCounterDet;
    input.title= 'emojiOptionText'+EmojiCounterDet;  ;
    input.placeholder = `${t('Feedback Setting.Enter Emoji Option Text')}`;
    var divEmojiOptions = document.getElementById('emojiOptions'); 
    optionDiv.appendChild(input); 
    var emojiList=this.props.feedbackSettings.emojiImage;
    
    emojiList.forEach(item => {
        var inputlbl ;
        inputlbl = document.createElement('label');
      inputlbl.key="EmojiImage"+item.Id;
      inputlbl.className="checkbox-inline";

 var  inputRad = document.createElement('input');
 inputRad.type = 'radio';
 inputRad.id='EmojiImageCB'+EmojiCounterDet;
 inputRad.name = 'EmojiImage'+EmojiCounterDet;  
 inputRad.key=item.Id;
 inputRad.value=item.Id;

 var  inputImg = document.createElement('img');
 inputImg.src=baseUrl+item.EmojiImage;
 inputImg.style.width="30px";
 inputImg.style.height="30px";

 inputlbl.appendChild(inputRad);
 inputlbl.appendChild(inputImg);
 var divEmojiOptions = document.getElementById('emojiOptions'); 
 optionDiv.appendChild(inputlbl);  
      }); 
    var inputSpanDelete = document.createElement('span');
    inputSpanDelete.tooltip="Delete";
    inputSpanDelete.onclick =this.DeleteEmojiOption;
    inputSpanDelete.id='emojiOptionDel_'+EmojiCounterDet;
    var nbsp = document.createElement('span');
                nbsp.innerHTML="&nbsp";
                inputSpanDelete.appendChild(nbsp);
 var inputIDelete = document.createElement('i');
 inputIDelete.className="fa fa-lg fa-trash";
 inputIDelete.ariaHidden="true";
 inputSpanDelete.appendChild(inputIDelete);
 optionDiv.appendChild(inputSpanDelete);
 divEmojiOptions.appendChild(optionDiv);
}
 
    openModal(rowDatas) { 
        this.setState({ open: true })    
        var QuesTypeID;
        sleep(500).then(() => {  
            document.getElementById("lblQuestionId").value = rowDatas.QuestionId;
            document.getElementById("questionText").value = rowDatas.QuestionText;  
            if(rowDatas.TypeId == 1) 
                QuesTypeID="1"  
             if(rowDatas.TypeId == 2)
             QuesTypeID="2"; 
             if(rowDatas.TypeId == 3)
             QuesTypeID="3"; 
             document.getElementById("questionTypeDD").value=QuesTypeID; 
            // if(rowDatas.Mandatory == true){
            //   document.getElementById("Mandatory_True").checked = true;
            //   document.getElementById("Mandatory_False").checked = false;
            // }
            // else{
            //     document.getElementById("Mandatory_True").checked = false;
            //     document.getElementById("Mandatory_False").checked = true;
            // } 
            // if(rowDatas.QuestionHidden == true){
            //     document.getElementById("Hidden_True").checked = true;
            //     document.getElementById("Hidden_False").checked = false;
            //   }
            //   else{
            //       document.getElementById("Hidden_True").checked = false;
            //       document.getElementById("Hidden_False").checked = true;
            //   }  
        })
        
        if(rowDatas.TypeId == 1) 
                QuesTypeID="1"  
             if(rowDatas.TypeId == 2)
             QuesTypeID="2"; 
             if(rowDatas.TypeId == 3)
             QuesTypeID="3"; 
         this.setState( prevState => ({ feedbackSettings : 
        {...prevState.feedbackSettings, 
            QuestionId:rowDatas.QuestionId,
            QuestionText:rowDatas.QuestionText,
            QuestionTypeId:QuesTypeID, 
            FeedbackTypeId : rowDatas.Answers[0].FeedbackTypeId,
            // Mandatory:rowDatas.Mandatory =='True'?true:false, 
            // Hidden:rowDatas.QuestionHidden=='True'?true:false,  
        }
        }),  ) 
        if(rowDatas.TypeId == 2){
            this.createOptionsTextbox();
        }
        if(rowDatas.TypeId == 3){
            this.createEmojiOptions();
        }

    }
 
    
    handleError=()=>{
        this.setState({
            rowimage:noimage
         });
    }
 
    
    deleteQuestionDetails(rowDatas){ 
        const { t } = this.props;
        confirmAlert({
          title: `${t('First_Responder.Confirm to delete')}`,
          message: `${t('First_Responder.Are you sure to delete this?')}`,
          buttons: [
            {
              label: `${t('First_Responder.Yes')}`,
              onClick: () => {
                let questionId=rowDatas.QuestionId
                let feedbackSettings = this.state.feedbackSettings;    
                 this.props.deleteQuestionDetails({ QuestionId :questionId});
            }
            },
            {
              label: `${t('First_Responder.No')}`,
              onClick: () => {
              }
            }
          ]
        });
    } 

    actionColumn(rowDatas) {  
        const { t } = this.props;
            return (
                <span>
                    <span onClick={() => { this.openModal(rowDatas) }} className="enable-cursor editicon" title={t('First_Responder.View')}>   
                        <i className="fa fa-pencil" aria-hidden="true"></i></span>
                    
                    <span onClick={() => { this.deleteQuestionDetails(rowDatas)  }} title={t('First_Responder.Delete')} className="enable-cursor"> 
                    <i className="fa fa-lg fa-trash" aria-hidden="true"></i>
                    </span>   
                </span>
            ) 

    }

    updateQuestionDetailsSettings() {
        const { t } = this.props;
        if (this.validator.allValid()) {  
            let feedbackSettings = this.state.feedbackSettings;   
             var formData={};
            if(feedbackSettings.QuestionTypeId == ''){
                this.setState( prevState => ({
                    notificationSettings : 
                    {...prevState.feedbackSettings,
                        QuestionTypeId: document.getElementById("questionTypeDD").value, 
                    }  
                  })) 
            } 
            sleep(1000).then(() => {  
                feedbackSettings = this.state.feedbackSettings;    
                formData.QuestionId=feedbackSettings.QuestionId;
               formData.QuestionTypeId=feedbackSettings.QuestionTypeId;    
               formData.QuestionText=feedbackSettings.QuestionText;                   
            //    formData.Mandatory=feedbackSettings.Mandatory;
            //    formData.Hidden=feedbackSettings.Hidden;
               formData.FeedbackTypeId=feedbackSettings.FeedbackTypeId;

               var QuesList=this.props.feedbackSettings.questionList;
               QuesList= QuesList.filter(m=>m.QuestionId == this.state.feedbackSettings.QuestionId)[0];
               var QuesListAns=QuesList.Answers;
               if(feedbackSettings.QuestionTypeId == "2"){
                let mcqOptionsDiv = document.getElementById('mcqOptions');
                if(mcqOptionsDiv.childElementCount == 0){
                    swal(`${t('Feedback Setting.Please add option')}`);
                    return;
                }
               var elementRes= document.getElementById('mcqOptions').getElementsByTagName('div')
                var ansArray=[];
                for(var optionCount=0;optionCount< elementRes.length;optionCount++){ 
                    var ansObj={};
                    var elementIDsStr=elementRes[optionCount].id;
             var elementIDsArr=elementIDsStr.split('_');
             var elementIDs=elementIDsArr[1];
                    if(document.getElementById("mcqOptionText"+elementIDs).value){
                        ansObj.Option = document.getElementById("mcqOptionText"+elementIDs).value;
                    }
                    else{
                        document.getElementById("mcqOptionText"+elementIDs).style.border="1px solid #F00"; 
                        swal(`${t('Feedback Setting.Please enter value')}`);
                        document.getElementById("mcqOptionText"+elementIDs).onclick=function(){ this.style.border="2px solid #CCC"; }
                        return;
                    }
                    var IsExist= QuesListAns.filter(x => x.AnswerId == elementIDs)[0];
                    
                    if(IsExist != undefined)
                       ansObj.AnswerId=elementIDs;
                    else
                      ansObj.AnswerId=0;
                    ansArray.push(ansObj);
                   }
                   formData.AnswerList=ansArray;
            }
           else if(feedbackSettings.QuestionTypeId == "3"){ 
            let emojiOptionsDiv = document.getElementById('emojiOptions');
            if(emojiOptionsDiv.childElementCount == 0){
                swal(`${t('Feedback Setting.Please add option')}`);
                return;
            }
            var elementRes= document.getElementById('emojiOptions').getElementsByTagName('div')
            var ansArray=[];
            for(var optionCount=0;optionCount< elementRes.length;optionCount++){ 
             var ansObj={};
             var elementIDsStr=elementRes[optionCount].id;
             var elementIDsArr=elementIDsStr.split('_');
             var elementIDs=elementIDsArr[1];
             if(document.getElementById("emojiOptionText"+elementIDs).value){
                ansObj.Option = document.getElementById("emojiOptionText"+elementIDs).value;
             }
             else{
                document.getElementById("emojiOptionText"+elementIDs).style.border="1px solid #F00"; 
                swal(`${t('Feedback Setting.Please enter value')}`);
                document.getElementById("emojiOptionText"+elementIDs).onclick=function(){ this.style.border="2px solid #CCC"; }
                return;
             }
             var IsExist= QuesListAns.filter(x => x.AnswerId == elementIDs)[0];
                    
             if(IsExist != undefined)
                ansObj.AnswerId=elementIDs;
             else
               ansObj.AnswerId=0;
               var myChecked = 0;
             var ele=document.getElementsByName("EmojiImage"+elementIDs);
             for(var i = 0; i < ele.length; i++) { 
                // if(ele[i].checked) {
                //     ansObj.OptionEmoji = ele[i].value; 
                // }
                if (myChecked == 1) {
                    continue;                	
                } 
                if (ele[i].checked)  {
                    myChecked = 1;	
                    ansObj.OptionEmoji = ele[i].value;
                }
            }
            if(myChecked !== 1){
                swal(`${t('Feedback Setting.Choose one emoji')}`);
                return;
            }   
             ansArray.push(ansObj);
            }
            formData.AnswerList=ansArray; 
            }
            console.log(formData)
           this.props.updateQuestionDetailsSettings(formData);
            }) 
        }else {
            this.validator.showMessages(); 
            this.forceUpdate();
        }
        
    } 
     notify = (message) => { 
        swal({text : message, icon : 'success'})
    //   this.toastId =toast.success(message, {
    //     position: toast.POSITION.TOP_CENTER
    //   }); 
      this.closeModal(); 
    }
    
    // isMandatoryColumn(rowDatas) { 
    //     var Value="";
    //     if(rowDatas.Mandatory == false)
    //      Value="false";
    //     else
    //     Value="true"
    //     return (
    //         <span>
    //            {Value   }
    //         </span>
    //     ) 
    // }
    // isHiddenColumn(rowDatas) { 
    //     var Value="";
    //     if(rowDatas.QuestionHidden == false)
    //      Value="false";
    //     else
    //     Value="true"
    //     return (
    //         <span>
    //            {Value   }
    //         </span>
    //     ) 
    // }


    render() { 
        const { t } = this.props;
        let  optionQuestionType,optionEmojiImage, optionFeedbackType; 
        let QuestionTypeVal = this.props.feedbackSettings.questionType; 
        let feedbackTypeVal = this.props.feedbackSettings.FeedbackTypesList;

        if(QuestionTypeVal){
            optionQuestionType = QuestionTypeVal.map((QuestionTypeValue) =>
                <option value={QuestionTypeValue.QuestionTypeId} key={QuestionTypeValue.QuestionTypeId}>{QuestionTypeValue.QuestionTypes}</option>
            ); 
        }    
        if(feedbackTypeVal){
            optionFeedbackType = feedbackTypeVal.map((item) =>
                <option value={item.FeedbackTypeId} key={item.FeedbackTypeId}>{item.FeedbackType}</option>
            ); 
        }
        var header = <div className="search-name">
                        <i className="fa fa-search" style={{margin:'4px 4px 0 0'}}></i>
                        <InputText type="text" onInput={(e) => this.setState({globalFilter: e.target.value})} placeholder={t('First_Responder.Search')} size="50"/>
                    </div>;
        return (
            <div >
                <div className="progressbar-heading grids-heading">
                    <h2>{t('Feedback Setting.Application Feedback Questions List Details')}</h2>
                </div>
                {/* <ToastContainer />  */}
                 <div className="w3l_search m-b-15">
                    {header}
                </div>
                <div className="devicestable">
                    <div className="devicestable">
                    <DataTable  className="table no-border" value={this.props.feedbackSettings.questionList}  
                        globalFilter={this.state.globalFilter} paginator={true} rows={10}
                        emptyMessage={t('Feedback Setting.No records found')}
                        > 
                                    <Column sortable={true}  field="QuestionId" header=""  className="noDisplay" />
                                    {/* <Column sortable={true} headerClassName="hideheader" field="Mandatory" body={this.isMandatoryColumn}  header={t('Feedback Setting.Is Mandatory')} /> */}
                                    {/* <Column sortable={true} headerClassName="hideheader" field="QuestionHidden" header={t('Feedback Setting.Is Question Hidden')} body={this.isHiddenColumn}/> */}
                                    <Column sortable={true} headerClassName="hideheader" field="QuestionType" header={t('Feedback Setting.Question Type')}  />
                                    <Column sortable={true} headerClassName="hideheader" field="QuestionText" header={t('Feedback Setting.Question Text')}  /> 
                                    <Column sortable={true} headerClassName="hideheader" body={this.actionColumn} header={t('First_Responder.Action')}  />
                        </DataTable> 
                       
                    </div>
                </div>      
                <Modal open={this.state.open}  onClose={this.closeModal} center> 
                    <div className="modal1 alarmsetmodal">
                        <div className="progressbar-heading grids-heading">
                                 <h2>{t('Feedback Setting.Feebdack Question Answer Update')}</h2>
                        </div>

                            <div className="">
                                <div className="forms add-device setting-panel">
                                    <div className="form-three widget-shadow">
                                        <div className=" panel-body-inputin">
                                            <form className="form-horizontal" >
                                        <div className="form-group"> 
                                            <label className="col-sm-3 control-label"> {t('Feedback Setting.Feedback types')}</label>
                                             <div className="col-sm-9">
                                             <select disabled id="FeedbackTypeId"  className="form-control1 hide-text-field FR-edit-details"
                                                onChange={this.handleInput} 
                                                value = {this.state.feedbackSettings.FeedbackTypeId}
                                                placeholder="Select" 
                                                ref="FeedbackTypeId"
                                                name='FeedbackTypeId'
                                            >
                                                {optionFeedbackType}
                                            </select>
                                      </div>
                                            
                                        </div>
                                        <div className="form-group"> 
                                            <label className="col-sm-3 control-label"> {t('Feedback Setting.Feedback Question Text')}</label>
                                            <label id="lblQuestionId" className="noDisplay"/> 
                                            <div className="col-sm-9">
                                            <input 
                                                 id="questionText"  
                                                    type='text' 
                                                    title= 'QuestionText'
                                                    name= 'QuestionText'
                                                    defaultValue={this.state.feedbackSettings.QuestionText} 
                                                    placeholder =  {t('Feedback Setting.Enter Feedback Question')} 
                                                    onChange = {this.handleInput} 
                                                    className="form-control1 FR-edit-details" 
                                                    />  
                                            {this.validator.message(`${t('Feedback Setting.Question Text')}`, this.state.feedbackSettings.QuestionText, 'required|min:3')}
                                      </div>
                                            
                                        </div> 
                                        <div className="form-group"> 
                                            <label className="col-sm-3 control-label"> {t('Feedback Setting.Feedback Question Type')}</label>
                                             <div className="col-sm-9">
                                            <select  id="questionTypeDD"  className="form-control1 FR-edit-details"
                                            onChange={this.handleInput} 
                                            value = {this.state.feedbackSettings.QuestionTypeId}
                                            placeholder="Select" 
                                            ref="QuestionTypeId"
                                            name='QuestionTypeId'
                                        >
                                            {optionQuestionType}
                                        </select>
                                      </div>
                                            
                                        </div>
                                        {(this.state.feedbackSettings.QuestionTypeId == "2")?
                                        <div className="form-group"> 
                                            <label className="col-sm-3 control-label"> Options</label>
                                           <div className="col-sm-9" id="mcqOptions">
                                            
                                           </div>
                                           <button type="button" className="btn btn-primary general-btn" id="addMoreMcqOption" onClick={() => { this.createTextbox() }}>{t('Feedback Setting.Add Options')}</button>

                                        </div>:''}
                                        {(this.state.feedbackSettings.QuestionTypeId == "3")?
                                        <div className="form-group"> 
                                            <label className="col-sm-3 control-label"> Options</label>
                                             <div className="col-sm-9" id="emojiOptions">
                                          
                                           </div>
                                           <button type="button" className="btn btn-primary general-btn" id="addMoreEmojiOptionText" onClick={() => { this.createEmojiTextbox() }}>{t('Feedback Setting.Add Options')}</button>

                                        </div>:''}
                                        {/* <div className="form-group"> 
                                            <label className="col-sm-3 control-label"> {t('Feedback Setting.Is Mandatory')}</label>
                                             <div className="col-sm-9" >
                                             <label key="Mandatory" className="checkbox-inline">
                                                                    <input 
                                                                      id = "Mandatory_True"
                                                                      name="Mandatory"
                                                                      onChange={this.handleInput}
                                                                      value="True"
                                                                      key="Mandatory_True" 
                                                                      type="radio" /> {t('Feedback Setting.True')}
                                                                  </label> 
                                                                  <label  className="checkbox-inline">
                                                                    <input 
                                                                      id = "Mandatory_False"
                                                                      name="Mandatory"
                                                                      onChange={this.handleInput}
                                                                      value="False"
                                                                      key="Mandatory_False" 
                                                                      type="radio" /> {t('Feedback Setting.False')}
                                                                  </label> 
                                           </div>
                                            
                                        </div> */}
                                        {/* <div className="form-group"> 
                                            <label className="col-sm-3 control-label">  {t('Feedback Setting.Is Hidden')}</label>
                                             <div className="col-sm-9" >
                                            
                                             <label key="Hidden" className="checkbox-inline">
                                                                    <input 
                                                                      id = "Hidden_True"
                                                                      name="Hidden"
                                                                      onChange={this.handleInput}
                                                                      value="True"
                                                                      key="Hidden_True" 
                                                                      type="radio" /> {t('Feedback Setting.True')}
                                                                  </label> 
                                                                  <label  className="checkbox-inline">
                                                                    <input 
                                                                      id = "Hidden_False"
                                                                      name="Hidden"
                                                                      onChange={this.handleInput}
                                                                      value="False"
                                                                      key="Hidden_False" 
                                                                      type="radio" /> {t('Feedback Setting.False')}
                                                                  </label> 
                                           </div>
                                            
                                        </div> */}
                                        <div className="form-group"> 
                                            <div className="col-sm-offset-5 col-sm-6">      
                                            <p>
                                            <button 
                                                type="button"
                                                className="btn btn-primary general-btn" 
                                                onClick={() => { this.updateQuestionDetailsSettings()  }}
                                                >
                                                {t('First_Responder.Save')}
                                            </button>
                                            {
                                                this.props.feedbackSettings.isLoading?
                                                <img src={loader} width="30" alt="" />:''
                                            }
                                            </p>
                                            </div>
                                        </div>
                                   
                                   
                                 </form>
                                        </div>
                                    </div>
                                </div>      
                           
                            </div>                           
                           
                        
                    </div>
                </Modal>
            
            </div>
        )
    }
}

export default withNamespaces()(withRouter(AppFeedbackSettingComponent));